import _objectWithoutProperties from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _extends from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
var _excluded = ["isOpen"];
import React from "react";
import { Box, Flex } from "@catchoftheday/cg-components";
import { jsx as ___EmotionJSX } from "@emotion/react";
export var SearchBarWrapper = function SearchBarWrapper(props) {
  return ___EmotionJSX(Flex, _extends({
    pr: ["4px", null, "20px"],
    flexGrow: 1
  }, props));
};
export var SearchBoxZone = function SearchBoxZone(_ref) {
  var isOpen = _ref.isOpen,
      props = _objectWithoutProperties(_ref, _excluded);

  return ___EmotionJSX(Flex, _extends({
    flexGrow: 1,
    position: "relative",
    zIndex: isOpen ? 4 : 0
  }, props));
};
export var SuggestedSearchTermsZone = function SuggestedSearchTermsZone(props) {
  return ___EmotionJSX(Flex, _extends({
    width: {
      xs: "100%",
      md: "35.8%"
    },
    p: 5,
    bg: "ui.backgroundColor",
    borderBottomLeftRadius: "5px"
  }, props));
};
export var SuggestedProductsZone = function SuggestedProductsZone(props) {
  return ___EmotionJSX(Flex, _extends({
    p: "20px",
    flex: "1",
    width: {
      xs: "100%",
      md: "64.2%"
    }
  }, props));
};
export var Spacer = function Spacer() {
  return ___EmotionJSX(Box, {
    width: "57px"
  });
};